import styled, { css } from 'styled-components';

type TourBalloonComponent = {
  position: {
    left: string;
    right: string;
    top: string;
    arrowPosition: string;
    maxWidth?: number | string | null;
    boxShadow?: boolean;
    width?: string;
    transform?: string;
  };
};

export const Container = styled.div<TourBalloonComponent>`
  background-color: #ffff;
  padding: 16px;
  font-family: 'open sans';
  font-size: 0.85em;
  line-height: 1.6em;
  border-radius: 15px;
  height: auto;
  color: #fff;
  margin-top: 30px;
  width: fit-content;
  position: absolute;
  z-index: 1000;

  ${({ position }) =>
    position.boxShadow &&
    css`
      box-shadow: 0 1px 10px rgb(0 0 0 / 40%);
    `}

  ${({ position }) =>
    position.transform &&
    css`
      transform: ${position.transform};
    `}

  &:after {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-bottom: 20px solid #fff;
    border-top: 20px solid transparent;
    top: -20px;
    left: 20%;

    ${({ position }) =>
      position.arrowPosition === 'left' &&
      css`
        border-left: 20px solid transparent;
        border-right: 20px solid #ffff;
        border-bottom: 20px solid transparent;
        border-top: 20px solid transparent;
        top: 20%;
        left: -13%;
      `}

    ${({ position }) =>
      position.arrowPosition === 'right' &&
      css`
        border-left: 20px solid #ffff;
        border-right: 20px solid transparent;
        border-bottom: 20px solid transparent;
        border-top: 20px solid transparent;
        top: 20%;
        left: 98%;
      `}

      ${({ position }) =>
      position.arrowPosition === 'top' &&
      css`
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        border-bottom: 20px solid #fff;
        border-top: 20px solid transparent;
        top: -18%;
        left: 50%;
        transform: translateX(-50%);
      `}

      ${({ position }) =>
      position.arrowPosition === 'bottom' &&
      css`
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        border-bottom: 20px solid transparent;
        border-top: 20px solid #fff;
        top: 98%;
        left: 35%;
      `}
  }

  > span {
    color: #808492;
    ${({ position }) =>
      position.maxWidth !== 'unset' &&
      css`
        max-width: ${position?.maxWidth || 180}px;
      `};
    display: inline-block;
    font-family: 'Mangueira', sans-serif !important;

    ${({ position }) =>
      position.width &&
      css`
        width: ${position.width};
      `}
  }

  h5 {
    color: ${({ theme }) => theme.colors.blue};
    font-family: 'Mangueira', sans-serif !important;
  }

  div {
    > span {
      color: ${({ theme }) => theme.colors.blue};
      font-family: 'Mangueira', sans-serif !important;
      font-weight: bold;
      position: absolute;
      top: 8px;
      right: 16px;
      cursor: pointer;
    }
  }

  left: ${({ position }) => position.left};
  right: ${({ position }) => position.right};
  top: ${({ position }) => position.top};
`;

type ArrowWrapProps = {
  showBack?: boolean;
};

export const ArrowWrap = styled.div<ArrowWrapProps>`
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-content: center;

  ${({ showBack }) =>
    !showBack &&
    css`
      justify-content: flex-end;
    `}

  svg {
    cursor: pointer;
  }
`;
